import React from 'react'
import { $property } from './model'
import { useUnit } from 'effector-react'
import { CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import { changedDateFormat } from '../../../../libs/utils'
import { Divider } from 'antd'
import { PropertyTablePage } from '../widgets/propertiesTable'
import { Navigate } from 'react-router-dom'
import { path } from '../../../../libs'

export const PropertyDetails = () => {
  const property = useUnit($property)

  if (!property) {
    return <Navigate to={path.nova.properties.entry()} />
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Property</strong>
      </CCardHeader>
      <CCardBody>
        <div className="mt-2">
          <span className="text-muted">Property ID:</span> {property.id}
        </div>
        <div className="mt-2">
          <span className="text-muted">Property name:</span> {property.name}
        </div>
        <div className="mt-2">
          <span className="text-muted">Investment strategy:</span>{' '}
          {property.investmentStrategy}
        </div>
        <div className="mt-2">
          <span className="text-muted">Token amount:</span>{' '}
          {property.tokenAmount}
        </div>
        <div className="mt-2">
          <span className="text-muted">Starting property price:</span>{' '}
          {property.startingPropertyPrice}
        </div>
        <div className="mt-2">
          <span className="text-muted">Starting token price:</span>{' '}
          {property.startingTokenPrice}
        </div>
        <div className="mt-2">
          <span className="text-muted">Duration (in years):</span>{' '}
          {property.duration}
        </div>
        <div className="mt-2">
          <span className="text-muted">Dividend period starts at:</span>{' '}
          {changedDateFormat(new Date(property.dividendPeriodStartsAt))}
        </div>
        <Divider />
        <div className="mt-2">
          <span className="text-muted">Current property price:</span>{' '}
          {property.currentPropertyPrice}
        </div>
        <div className="mt-2">
          <span className="text-muted">Current token price:</span>{' '}
          {property.currentTokenPrice}
        </div>
        <div className="mt-2">
          <span className="text-muted">
            Current Primary token balance (funding amount):
          </span>{' '}
          {property.currentPrimaryTokenBalance}
        </div>
        <Divider />
        <PropertyTablePage data={property.propertyPercentIncomeYearly} />
      </CCardBody>
    </CCard>
  )
}
